import * as ROUTES from './routes';
import * as STATUS from './status';
import ACTIONS from './actions';
import REDUCERS from './reducers';
import * as ERECEIPTS from './eReceipts';

export { ROUTES, STATUS, ACTIONS, REDUCERS, ERECEIPTS };

export const PROGRESS_BAR_SHIPPING_TEXT = {
  STH: {
    101: 'Shipping',
    102: 'Shipped',
    105: 'Shipped',
    undefined: 'Shipped',
  },
  BOSS: {
    101: 'Arrival at Store',
    105: 'Arrived at Store',
    130: 'Arrival at Store',
    131: 'Arrived at Store',
    132: 'Arrived at Store',
    200: 'Arrived at Store',
    undefined: 'Arrived at Store',
  },
  BOPIS: {
    101: '',
    105: '',
    130: '',
    131: '',
    200: '',
  },
  APPLIANCE: {
    101: '',
    102: '',
    105: '',
  },
  BODFS: {
    101: '',
    105: '',
    109: '',
    111: '',
  },
  DFS: {
    101: '',
    105: '',
    109: '',
    111: '',
    401: '',
    1000: '',
  },
};

export const PROGRESS_BAR_DELIVERY_TEXT = {
  STH: {
    101: 'Est. Delivery',
    102: 'Est. Delivery',
    105: 'Delivered',
    undefined: 'Est. Delivery',
  },
  BOSS: {
    101: 'Ready for Pickup',
    130: 'Ready for Pickup',
    131: 'Ready for Pickup',
    132: 'Ready for Pickup',
    200: 'Picked up',
    undefined: 'Ready for Pickup',
  },
  BOPIS: {
    101: 'Ready for Pickup',
    131: 'Ready for Pickup',
    200: 'Picked up',
    undefined: 'Ready for Pickup',
  },
  APPLIANCE: {
    101: 'Delivery',
    102: 'Delivery',
    105: 'Delivered',
    108: 'Delivery',
    109: 'Delivery',
    110: 'Delivery Attempted',
    200: 'Order Fulfilled',
    undefined: 'Delivery',
  },
  BODFS: {
    101: 'Delivery',
    105: 'Delivered',
    109: 'Delivery',
    111: 'Delivery',
    undefined: 'Delivery',
  },
  DFS: {
    101: 'Delivery',
    105: 'Delivered',
    109: 'Delivery',
    111: 'Delivery',
    401: 'Delivery',
    1000: 'Delivered',
    undefined: 'Delivery',
  },
};

export const INPUT_ERRORS = {
  order: {
    invalid: [
      'Please provide your order number.',
      'For online orders, this starts with either the letter W or C.',
      'For in-store orders, this starts with the letter H.',
    ],
    incomplete: [
      'Please provide your complete order number. For online orders, you can find your order number in your confirmation email.',
    ],
  },
  email: {
    invalid: ['Please provide your email, formatted as you@domain.com.'],
    incomplete: ['Please provide your email, formatted as you@domain.com.'],
  },
  instore: {
    invalid: [
      'Please provide your order number.',
      'For online orders, this starts with either the letter W or C.',
      'For in-store orders, this starts with the letter H.',
    ],
    incomplete: ['Please provide your complete order number.'],
  },
  authInstore: {
    invalid: [
      'An order number is required. Please enter your order number.',
      'For in-store orders, this starts with the letter H.',
    ],
    incomplete: ['Please provide your complete order number.'],
  },
  phone: {
    invalid: ['Please provide your 10 digit phone number.'],
    incomplete: ['Please provide your 10 digit phone number.'],
  },
};

export const ERRORS = {
  DETAILS_CONTENT:
    'There was a temporary technical issue. Please try again shortly.',
  ERECEIPT_DETAIL:
    'There was a temporary technical issue with displaying your receipt details. Please try again shortly.',
  ERECEIPT_IMAGE_NOT_AVAILABLE:
    "We can't display your receipt image at this time.",
  DELIVERY_UPDATE_CONTENT:
    'Unable to update your delivery date, please try again later.',
  HEADER: "We're sorry.",
  INLINE: 'Inline',
  LINE_ITEM_ERROR_CODE: 'OS_COMLOCKORDER_ERR_2001',
  CANCEL_GENERAL:
    'A temporary connection error prevented your cancellation request from going through. Please try again.',
  CANCEL_LINE_ITEM:
    ', this item will soon be shipped and is no longer available to cancel online.',
  APPLIANCE_CANCEL_NO_LONGER_ELIGIBLE: `We're sorry, the appliances in this order can't be canceled at this time. If you need assistance, please call support at 1-800-430-3376`,
  GEN_ERROR: 'GEN_ERROR',
};

export const CANCELLATION = {
  ORDER_HEADER: 'Are you sure you want to cancel the following items?',
  SELECTION_HEADER: 'Please select the items you would like to cancel.',
  SELECTION_INFO: `The following items are currently eligible for cancellation. Items in your order that have shipped cannot be modified.`,
  SUCCESS_HEADER: `Your cancellation was successful`,
  SUCCESS_INFO: `The following items have been canceled. You will receive an email confirmation shortly.`,
};

export const ONLINE_STORE_ID = '8119';

export const RETURNS = {
  SECTION_HEADER: `Please let us know which items you'd like to return. Then select your quantity and the reason for making the return.`,
  SECTION_HEADER_SUB: `You can also return most online purchases at your nearest Home Depot store within 90 days (or 1 year if the purchase is on your Home
  Depot Credit Card).`,
};

export const FULFILLMENT_TEXT = {
  BOPIS: 'Pick up in Store',
  BOSS: 'Pick up in Store',
  STH: 'Ship To Home',
  APPLIANCE: 'Appliance Delivery',
  BODFS: 'Express Delivery',
  DFS: 'Express Delivery',
  MISC: 'In-Store Purchase',
};

export const CARD_TYPES = {
  VI: {
    class: 'visa',
    text: 'Visa',
  },
  AX: {
    class: 'amex',
    text: 'American Express',
  },
  MA: {
    class: 'master',
    text: 'Mastercard',
  },
  DS: {
    class: 'disc',
    text: 'Discover',
  },
  HC: {
    class: 'hdcon',
    text: 'HD Consumer',
  },
  HR: {
    class: 'hdcom',
    text: 'HD Commercial Revolving',
  },
  HD: {
    class: 'hdcom',
    text: 'HD Commercial',
  },
  GR: {
    class: 'giftcard',
    text: 'Giftcard',
  },
  PP: {
    class: 'paypal',
    text: 'Paypal',
  },
  HI: {
    class: 'homeimrpover',
    text: 'Home Improver',
  },
  HA: {
    class: 'propurchase',
    text: 'Pro Purchase',
  },
  DB: {
    class: 'debit',
    text: 'Debit',
  },
  CS: {
    class: 'cash',
    text: 'Cash',
  },
};

export const FULFILLMENTS = {
  STH: 'STH',
  FULFILLMENT_METHOD_STH: 'ShipToHome',
  BOSS: 'BOSS',
  FULFILLMENT_METHOD_BOSS: 'BuyOnlineShipToStore',
  BOPIS: 'BOPIS',
  FULFILLMENT_METHOD_BOPIS: 'BuyOnlinePickupInStore',
  BODFS: 'BODFS',
  FULFILLMENT_METHOD_BODFS: 'BuyOnlineDeliverFromStore',
  APPLIANCE: 'APPLIANCE',
  FULFILLMENT_METHOD_APPLIANCE: 'Appliance',
  MISC: 'MISC',
  FULFILLMENT_METHOD_MISC: 'MISC',
  DFS: 'DFS',
  FULFILLMENT_METHOD_DFS: 'DFS',
};

export const ORDER_HISTORY_FILTERS = {
  SIX_MONTHS: 'The last 6 months',
  ALL_TIME: 'All time',
};

export const PARTS_AND_SERVICES = 'DD_RELATED_PRODUCT';
